import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import GlobalArticlesPanel from '../../components/templates/admin/GlobalArticlesPanel/GlobalArticlesPanel';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';

const GlobalArticlesPage = () => {
  const { user } = useAuth();

  // Proteção extra: Apenas admin e mensure
  if (user && !['admin', 'mensure'].includes(user.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <AdminLayout>
      <GlobalArticlesPanel />
    </AdminLayout>
  );
};

export default GlobalArticlesPage;
